<template>
  <abstract-strategy-page :endpoints="endpoints" v-on:item-selected="selectItem" v-on:change="listChange" ref="abstract" withOverriden>
    <template v-slot:itemCard>
      <ValidationObserver ref="validator" tag="div">
        <pricing-strategy-component :value="selectedItem" v-on:save="save" v-on:delete="deleteItem" v-on:close="closeSelectedItem" />
      </ValidationObserver>
    </template>
  </abstract-strategy-page>
</template>

<script>
import PricingStrategyComponent from '@/components/Pricing/PricingStrategyComponent.vue'
import Api from '../../../openapi/src/api/PricingStrategyApi'
import SortStrategiesDTO from '../../../openapi/src/model/SortStrategiesDTO'
import AbstractStrategyPage from '../../Backend/Pages/AbstractStrategy/AbstractStrategyPage.vue'
import PricingStrategyMixins from './PricingStrategyMixins'

const api = new Api()
export default {
  name: 'PricingStrategy',
  components: {
    PricingStrategyComponent,
    AbstractStrategyPage,
  },
  data() {
    return {
      selectedItem: null,
      endpoints: {
        get: api.getPricingStrategy.bind(api),
        list: api.getPricingStrategies.bind(api),
        save: api.insertPricingStrategy.bind(api),
        update: api.updatePricingStrategy.bind(api),
        delete: api.deletePricingStrategy.bind(api),
        create: (data) => this.createDto(data),
        duplicate: api.duplicatePricingStrategy.bind(api),
      },
    }
  },
  mixins: [PricingStrategyMixins],
  methods: {
    newStrategy() {
      this.pricings.push({
        name: 'New Pricing',
      })
      this.selectedPricingIndex = this.pricings.length - 1
    },
    selectItem(item) {
      this.selectedItem = null
      if (item.id && (!this.selectedItem || this.selectedItem.id != item.id))
        api.getPricingStrategy(this.$root.hotelId, item.id, (error, data) => {
          this.selectedItem = data
        })
      else if (!item.id) {
        this.selectedItem = item
      }
    },
    async save(item) {
      const isValid = await this.$refs.validator.validate()
      if (isValid) {
        if (item.id) {
          this.endpoints.update(this.$root.hotelId, item.id, this.endpoints.create(item), (error, data) => {
            if (!error) {
              this.showNotifications(data)
            }
          })
        } else {
          this.endpoints.save(this.$root.hotelId, this.endpoints.create(item), (error, data) => {
            if (!error) {
              this.selectedItem = data
              this.showNotifications(data)
            }
          })
        }
      } else {
        this.$notify({
          timeout: 2500,
          message: '<strong>Not saved</strong>. Please check your inputs',
          icon: 'check_box',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
      }
    },
    showNotifications(response) {
      if (response.conflict) {
        this.$notify({
          timeout: 8000,
          message: 'Some of the rules are incompatible, they will be applied in order of placement',
          icon: 'warning',
          horizontalAlign: 'right',
          verticalAlign: 'top',
          type: 'danger',
        })
      }
      this.$refs['abstract'].saved(response)
    },
    deleteItem(item) {
      this.selectedItem = null
      this.$nextTick().then(() => {
        if (item.id)
          this.endpoints.delete(this.$root.hotelId, item.id, (error, data) => {
            if (!error) this.$refs['abstract'].deleteSelected()
          })
        else this.$refs['abstract'].deleteSelected()
      })
    },
    closeSelectedItem() {
      this.selectedItem = null
      this.$refs['abstract'].unselectItem()
    },
    listChange(data) {
      if (data) {
        let list = new SortStrategiesDTO()
        list.strategy_ids = data.map((x) => x.id).filter((x) => x)
        api.sortPricingStrategy(this.$root.hotelId, list, (error, data) => {
          this.$refs.abstract.retrieveStrategies()
        })
      }
    },
  },
}
</script>
